import { Vue, Component } from 'vue-property-decorator';
import { VbSnackbarService } from 'bag-of-holding-library';
import AgreementLimitService, {
  AgreementLimit,
  AgreementLimitType,
} from '@/domain/employees/service/agreement-limit.service';

@Component
export default class AgreementLimitGuardMixin extends Vue {
  agreementLimit: AgreementLimit | null = null;

  loadingAgreementLimit: boolean = false;

  agreementLimitLoadFailed: boolean = false;

  async loadAgreementLimit(
    agreementType: AgreementLimitType,
    isLeader: boolean,
  ): Promise<void> {
    this.loadingAgreementLimit = true;
    this.agreementLimit = null;
    this.agreementLimitLoadFailed = false;
    try {
      this.agreementLimit = await AgreementLimitService.getCurrentAgreementLimit(
        agreementType,
        isLeader,
      );
    } catch (error) {
      this.agreementLimitLoadFailed = true;
      const backendMessages = this.extractBackendMessages(error);
      const reason = backendMessages.length
        ? backendMessages.join(' ')
        : 'Não foi possível carregar a configuração de limites de acordo.';
      VbSnackbarService.showError(`${reason} Não é possível seguir com o cadastro do acordo enquanto a configuração não existir.`);
    } finally {
      this.loadingAgreementLimit = false;
    }
  }

  private extractBackendMessages(error: any): string[] {
    const data = error && error.response && error.response.data;
    return data && Array.isArray(data.messages) ? data.messages : [];
  }

  get maxDuczSyndicateRatio(): number {
    return this.agreementLimit ? this.agreementLimit.duczSyndicateFreePercent / 100 : 0;
  }

  get maxBenefitRatio(): number {
    return this.agreementLimit ? this.agreementLimit.benefitSumPercent / 100 : 0;
  }

  get maxTotalMultiplier(): number {
    return this.agreementLimit
      ? 1 + (this.agreementLimit.totalReadjustmentPercent / 100)
      : 1;
  }

  get duczFoodMinimumValue(): number {
    return this.agreementLimit ? this.agreementLimit.duczFoodMinimumValue : 0;
  }

  get duczFoodMaximumValue(): number {
    return this.agreementLimit ? this.agreementLimit.duczFoodMaximumValue : 0;
  }

  get duczFreeMinimumValue(): number {
    return this.agreementLimit ? this.agreementLimit.duczFreeMinimumValue : 0;
  }
}
